import React, { useEffect, useRef, useState } from "react";
import {
  FieldArray,
  FormikProvider,
  useFormik,
  Field,
  Form,
  ErrorMessage,
} from "formik";
import * as Yup from "yup";
import * as jnb from "react-bootstrap";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";

const CourseChangerMrgeClosure = ({ typee, courseData }) => {
  const [course, setCourse] = useState({});
  const [mergeStatus, setMergeStatus] = useState(false);
  const [showEditTable, setShowEditTable] = useState(false);
  const [enhanceStatus, setEnhanceStatus] = useState(false);
  const initialValues = {
    selectedCourses: [],   // ✅ ADD THIS
    intakeDetails: [],
    courseChangeDetails: [
      {
        existing_course: "",
        existing_intake: "",
        proposed_change_name: "",
        revised_intake: "",
        nature: "",
        course_cat_id: ""
      },
    ],
    justification: "",
  };

  const validationSchema = Yup.object().shape({
    courseChangeDetails: Yup.array().of(
      Yup.object().shape({
        existing_course: Yup.string().required(ERROR_MSG),
        existing_intake: Yup.string().required(ERROR_MSG),

        proposed_change_name:
          typee === "close"
            ? Yup.mixed().notRequired()
            : Yup.mixed().required(ERROR_MSG),

        revised_intake:
          typee === "close"
            ? Yup.string().notRequired()
            : Yup.string().required(ERROR_MSG),

        // nature: Yup.string().required(ERROR_MSG),
      }),
    ),
    justification: Yup.string().required(ERROR_MSG),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to save the details?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            intakeType: typee,
            changecloselist: values.courseChangeDetails.map((item) => ({
              courseId: parseInt(item.existing_course),
              courseGrcode: item.course_group_code,   // ✅ FIXED
              courseType: item.course_cat_id,           // ✅ FIXED
              existingIntake: parseInt(item.existing_intake) || 0,
              proposedName: item.proposed_change_name,
              revisedIntake: parseInt(item.revised_intake) || 0,
              // nature: item.nature,
              nature: typee === "merger" ? "Merger" :
                typee === "course" ? "NameChange" :
                  "Closure",
              justification: values.justification,
            })),
          };
          const url = `${config.url.FAC_URL}saveIntakeChanges`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc,
                  icon: "success",
                  backdrop: false,
                  confirmButtonText: "OK",
                }).then((result) => {
                  if (result.isConfirmed) {
                    GetIntakeDetails();
                  }
                });
              } else {
                Swal.fire({
                  text: res.data?.sdesc,
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error("Submission Error:", err);
              Swal.fire({
                text: "An error occurred during submission.",
                icon: "error",
              });
            });
        }
      });
    },
  });
  /* SELECT ALL */
  const handleSelectAll = (e) => {
    if (enhanceStatus) {
      Swal.fire({ icon: "warning", text: "Already Edited" });
      return;
    } else {
      setShowEditTable(false);
      if (e.target.checked) {
        const allIds = courseData.map((c) => c.sno);
        setFieldValue("selectedCourses", allIds);
      } else {
        setFieldValue("selectedCourses", []);
      }
    }
  };

  /* ROW SELECT */
  const handleRowSelect = (sno, checked) => {
    if (enhanceStatus) {
      Swal.fire({ icon: "warning", text: "Already Edited" });
      return;
    } else {
      if (checked) {
        setShowEditTable(false);
        setFieldValue("selectedCourses", [...values.selectedCourses, sno]);
      } else {
        setFieldValue(
          "selectedCourses",
          values.selectedCourses.filter((id) => id !== sno),
        );
      }
    }
  };

  /* EDIT */
  const handleEdit = () => {
    const selectedRows = courseData.filter((course) =>
      values.selectedCourses.includes(course.sno),
    );

    const data = selectedRows.map((c) => ({
      sno: c.sno,
      course_id: c.course_id,
      course_name: c.course_name,
      intake: c.intake,
      course_cat_id: c.course_cat_id,
      course_cat_name: c.course_cat_name,
      course_group_code: c.course_group_code,
      course_group_desc: c.course_group_desc,
      change_value: "",
      effective: "",
      aicte_ref: "",
    }));

    // ✅ existing
    setFieldValue("intakeDetails", data);

    // ✅ ADD THIS (important fix)
    const changeData = selectedRows.map((c) => ({
      existing_course: c.course_id,
      existing_intake: c.intake,
      proposed_change_name: "",
      revised_intake: "",
      nature: "",
      course_group_code: c.course_group_code,   // needed for API
      course_type: c.course_noc_type,           // needed for API
    }));

    setFieldValue("courseChangeDetails", changeData);

    setShowEditTable(true);

    const el = document.getElementById("editTable");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  //  ********** field array get api************
  const GetIntakeDetails = (typee) => {

    const intakeType =
      typee === "course"
        ? "NameChange"
        : typee === "merger"
          ? "Merger"
          : "Closure";

    const url = `${config.url.FAC_URL}getInputDetails/${intakeType}`;

    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.close_status && Array.isArray(res.data.close) && res.data.close.length > 0) {
          setMergeStatus(res.data.close_status);
          setEnhanceStatus(true);   // ← ADD THIS

          const mappedData = res.data.close.map((item) => ({
            existing_course: item.course_id ?? "",
            existing_intake: item.existing_intake ?? "",
            proposed_change_name: item.proposed_name ?? "",
            revised_intake: item.revised_intake ?? "",
            nature: item.nature ?? "",
          }));
          formik.setFieldValue("courseChangeDetails", mappedData);

          // ← NEW: populate intakeDetails for the second table
          const intakeDetails = res.data.close.map((item) => {
            const course = courseData.find(c => c.course_id === item.course_id);
            return {
              sno: course?.sno || null,
              course_id: item.course_id,
              course_name: course?.course_name || "",
              intake: item.existing_intake,
              course_cat_id: course?.course_cat_id,
              course_cat_name: course?.course_cat_name,
              course_group_code: course?.course_group_code,
              course_group_desc: course?.course_group_desc,
              course_type: course?.course_noc_type,
              change_value: item.proposed_name,
              effective: item.revised_intake,
              aicte_ref: item.nature,
            };
          }).filter(row => row.sno); // only keep rows where we found the original course

          formik.setFieldValue("intakeDetails", intakeDetails);
          formik.setFieldValue("justification", res.data.close[0]?.justification ?? "");
          setShowEditTable(true);   // ← SHOW THE TABLE

        } else {
          setMergeStatus(false);
          setEnhanceStatus(false);
          formik.setFieldValue("courseChangeDetails", [
            {
              existing_course: "",
              existing_intake: "",
              proposed_change_name: "",
              revised_intake: "",
              nature: "",
            },
          ]);
          formik.setFieldValue("intakeDetails", []);
          formik.setFieldValue("justification", "");
          setShowEditTable(false);
        }
      })
      .catch((err) => {
        console.error("Error fetching intake details:", err);
      });
  };

  useEffect(() => {
    if (typee) {
      GetIntakeDetails(typee);
      console.log("useeffect>>", typee);
    }
  }, [typee]);
  const formikRef = useRef();
  useEffect(() => {
    // ✅ Clear selected checkboxes
    formik.setFieldValue("selectedCourses", []);
    // ✅ Clear edit tables
    formik.setFieldValue("intakeDetails", []);
    formik.setFieldValue("courseChangeDetails", [
      {
        existing_course: "",
        existing_intake: "",
        proposed_change_name: "",
        revised_intake: "",
        nature: "",
        course_cat_id: ""
      },
    ]);
    // ✅ Clear justification
    formik.setFieldValue("justification", "");

    // ✅ Hide edit section
    setShowEditTable(false);
    setEnhanceStatus(false);
  }, [typee]);
  const { values, setFieldValue } = formik;
  function GetCoursesByProgramType(course_group_code, index) {
    if (!course_group_code) return;

    let url = `${config.url.FAC_URL}getSpecilization/${course_group_code}`;

    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setCourse((prev) => ({
          ...prev,
          [index]: res.data.Specilization || [],
        }));
      } else {
        setCourse((prev) => ({
          ...prev,
          [index]: [],
        }));
      }
    });
  }
  useEffect(() => {
    const course_cat_id = formik.values.intakeDetails
      .map((item) => item.course_cat_id)
      .join(",");

    console.log("course_cat_id:", course_cat_id);

    // ✅ CALL API HERE
    formik.values.intakeDetails.forEach((row, index) => {
      if (row.course_cat_id) {
        GetCoursesByProgramType(row.course_cat_id, index);
      }
    });

    values.courseChangeDetails.forEach((row, index) => {
      if (row.course_cat_id) {
        GetCoursesByProgramType(row.course_cat_id, index);
        console.log("data", row.course_cat_id, index)
      }
    });
  }, [values.courseChangeDetails, formik.values.intakeDetails]);
  return (
    <>
      <h5 className="mb-3 innerheader-new">
        <span> Course Change / Merger / Closure Details</span>
      </h5>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-primary">
            <tr>
              <th>
                {!enhanceStatus ? (
                  <>
                    <input
                      type="checkbox"
                      checked={
                        courseData.length > 0 &&
                        values.selectedCourses.length === courseData.length
                      }
                      onChange={handleSelectAll}
                    />{" "}
                    SL.No
                  </>
                ) : (
                  "SL.No"
                )}
              </th>
              <th>Academic Program Type</th>
              <th>Course / Program</th>
              <th>Branch/Specialization</th>
              <th>Medium</th>
              <th>Regular/Self Financed</th>
              <th>Permanent/Temporary</th>
              <th>Intake</th>
            </tr>
          </thead>
          <tbody>
            {courseData.length > 0 ? (
              courseData.map((course, index) => (
                <tr key={course.sno}>
                  <td>
                    {!enhanceStatus ? (
                      <>
                        <input
                          type="checkbox"
                          checked={values.selectedCourses.includes(course.sno)}
                          onChange={(e) =>
                            handleRowSelect(course.sno, e.target.checked)
                          }
                        />{" "}
                        {index + 1}
                      </>
                    ) : (
                      index + 1
                    )}
                  </td>

                  <td>{course.course_group_desc}</td>
                  <td>{course.course_cat_name}</td>
                  <td>{course.course_name}</td>
                  <td>{course.medium_name}</td>
                  <td>
                    {course.reg_self === "S"
                      ? "Self Finance"
                      : course.reg_self === "R"
                        ? "Regular"
                        : ""}
                  </td>
                  <td>{course.course_noc_type}</td>
                  <td>{course.intake}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center text-danger fw-bold">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {!enhanceStatus && (
        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleEdit}
            disabled={!values.selectedCourses.length}
          >
            Edit
          </button>
        </div>
      )}

      {/* SECOND TABLE */}

      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>







          {showEditTable && (
            <>
              <h5 className="mb-3 mt-3 innerheader-new">
                <span>Modified Course Intake Details</span>
                {typee === "close" && (
                  <>
                    <h6 className="text-danger mt-2">
                      These courses will be permanently closed and will not be available for future intake.
                    </h6>
                  </>
                )}
              </h5>
              <FieldArray name="courseChangeDetails">
                {() => (
                  <div id="editTable" className="table-responsive">
                    <table className="table table-hover align-middle mt-4">
                      <thead className="table-primary">
                        <tr className="small text-uppercase">
                          <th className="text-center">Sl.No</th>
                          <th>Academic Program Type</th>
                          <th>Course / Program </th>
                          <th>Course / Branch</th>
                          <th width="140px">Existing Intake</th>
                          {typee !== "close" && (
                            <>
                              <th>Proposed Change / New Name</th>
                              <th width="140px">Revised Intake</th>
                            </>
                          )}
                          {/* <th width="180px">Nature</th> */}
                        </tr>
                      </thead>
                      <tbody>

                        {values.courseChangeDetails.map((row, index) => (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>


                            <td>
                              {
                                courseData.find(
                                  (c) => c.course_id === row.existing_course
                                )?.course_group_desc || ""
                              }
                            </td>

                            <td>
                              {
                                courseData.find(
                                  (c) => c.course_id === row.existing_course
                                )?.course_cat_name || ""
                              }
                            </td>
                            <td>
                              {
                                courseData.find(
                                  (c) => c.course_id === row.existing_course
                                )?.course_name || ""
                              }
                            </td>
                            <td>
                              <input
                                value={row.existing_intake}
                                className="form-control form-control-sm"
                                disabled
                              />
                            </td>


                            {/* ✅ Proposed Change */}
                            {console.log("course state:", course)}
                            {typee !== "close" && (
                              <>
                                <td>
                                  <Field
                                    as="select"
                                    name={`courseChangeDetails[${index}].proposed_change_name`}
                                    className="form-control form-control-sm"
                                    disabled={enhanceStatus}
                                  >
                                    <option value="">Select Course</option>

                                    {course[index] && course[index].map((c) => (
                                      <option key={c.course_id} value={c.course_id}>
                                        {c.course_name}
                                      </option>
                                    ))}
                                  </Field>


                                  {/* <ErrorMessage
                                    name={`courseChangeDetails[${index}].proposed_change_name`}
                                    component="div"
                                    className="text-danger small mt-1"
                                  /> */}
                                  {typee !== "close" && (
                                    <ErrorMessage
                                      name={`courseChangeDetails[${index}].proposed_change_name`}
                                      component="div"
                                      className="text-danger small mt-1"
                                    />
                                  )}
                                </td>

                                <td>
                                  <Field
                                    name={`courseChangeDetails[${index}].revised_intake`}
                                    className="form-control form-control-sm"
                                    disabled={enhanceStatus}
                                  />

                                  {typee !== "close" && (
                                    <ErrorMessage
                                      name={`courseChangeDetails[${index}].revised_intake`}
                                      component="div"
                                      className="text-danger small mt-1"
                                    />
                                  )}
                                </td>
                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </FieldArray>

            </>
          )}
          {/* Justification Section */}
          <div className="mt-4">
            <label className="form-label fw-bold text-dark mb-2">
              <i className="bi bi-chat-left-dots me-2 text-primary"></i>
              Justification <span className="text-danger">*</span>
            </label>
            <div className="p-2 bg-light rounded border">
              <Field
                as="textarea"
                name="justification"
                className="form-control border-0 shadow-none bg-transparent"
                rows="3"
                placeholder="Provide detailed justification for the proposed change(s)..."
              />
            </div>
            <ErrorMessage
              name="justification"
              component="div"
              className="text-danger small mt-1"
            />
          </div>

          {!mergeStatus && values.courseChangeDetails.some(row => row.existing_course) ? (
            <jnb.Row className="mt-4">
              <jnb.Col>
                <div className="d-flex justify-content-end mt-4">
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                </div>
              </jnb.Col>
            </jnb.Row>
          ) : mergeStatus ? (
            <jnb.Row className="mt-4">
              <jnb.Col>
                <div className="d-flex justify-content-end mt-4">
                  <span className="text-success fw-bold">
                    Already Submitted
                  </span>
                </div>
              </jnb.Col>
            </jnb.Row>
          ) : null}
        </Form>
      </FormikProvider>

      <style>{`
                .btn-icon { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; padding: 0; border-radius: 6px; }
                .extra-small { font-size: 0.75rem; }
                .table-dark { --bs-table-bg: #2d3436; }
                .form-control:focus, .form-select:focus { border-color: #74b9ff; box-shadow: 0 0 0 0.2rem rgba(116, 185, 255, 0.25); }
            `}</style>
    </>
  );
};

export default CourseChangerMrgeClosure;